<template>
  <div class="schedule-pager">
    <div class="schedule-pager-weeks">
      <div
        class="schedule-pager-weeks-button schedule-pager-weeks-button-prev"
        @click="changeWeek(-1)">
        <i class="fas fa-chevron-left"></i>
      </div>

      <div class="schedule-pager-weeks-current">
        {{formatDate(dateFrom)}} - {{formatDate(dateTo)}}
      </div>

      <div
        class="schedule-pager-weeks-button schedule-pager-weeks-button-next"
        @click="changeWeek(1)">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>

    <div class="schedule-pager-days">
      <div
        v-for="(day, dayKey) in days" :key="dayKey"
        :class="'schedule-pager-days-item ' + (day.isCurrent ? 'selected' : '')"
        @click="selectDay(day.date)">
        {{day.name}}
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../utils/formatDate';
  import {MS_IN_DAY, CALENDAR_DAY_ABBR} from '../../constants';

  export default {
    name: 'SchedulePager',

    props: ['date', 'setDate'],

    data() {
      return {};
    },

    computed: {
      dateFrom() {
        const shift = this.date.getDay() === 0 ? 6 : this.date.getDay() - 1;

        return new Date(this.date.getTime() - shift * MS_IN_DAY);
      },

      dateTo() {
        return new Date(this.dateFrom.getTime() + 6 * MS_IN_DAY);
      },

      days() {
        const days = [];
        const from = this.dateFrom.getTime();
        const to = this.dateTo.getTime();

        for (let i = from; i <= to; i += MS_IN_DAY) {
          const date = new Date(i);

          days.push({
            date,
            name: CALENDAR_DAY_ABBR[date.getDay()],
            isCurrent: this.date.getDay() === date.getDay(),
          });
        }

        return days;
      },
    },

    methods: {
      changeWeek(step) {
        this.setDate(new Date(this.date.getTime() + step * 7 * MS_IN_DAY));
      },

      selectDay(date) {
        this.setDate(date);
      },

      formatDate(date) {
        return formatDate(date, 'd.m.y');
      },
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .prescription-page {
    .schedule-pager-weeks {
      position: relative;

      .schedule-pager-weeks-button {
        position: absolute;
        top: 50%;
        height: 30px;
        margin: -20px 0 0 0;
        font-size: 26px;
      }

      .schedule-pager-weeks-button-prev {
        left: 50%;
        margin-left: -140px;
      }

      .schedule-pager-weeks-current {
        width: 200px;
        margin: 0 auto;
        padding: 5px 0;
        text-align: center;
        background-color: $secondary;
        border-radius: 20px;
      }

      .schedule-pager-weeks-button-next {
        right: 50%;
        margin-right: -140px;
      }
    }

    .schedule-pager-days {
      padding: 20px 0;
      text-align: center;

      .schedule-pager-days-item {
        display: inline-block;
        width: 35px;
        height: 35px;
        margin: 0 2px;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        line-height: 35px;
        color: $secondary;
        border-radius: 18px;

        &.selected {
          background-color: $dark;
        }
      }
    }
  }
</style>
